import { render, staticRenderFns } from "./bullSemenDespatchNote.vue?vue&type=template&id=06c3a6e0&scoped=true&"
import script from "./bullSemenDespatchNote.vue?vue&type=script&lang=js&"
export * from "./bullSemenDespatchNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3a6e0",
  null
  
)

export default component.exports